import React, { useEffect, useState } from "react";
import BreadCrumbs from "../../Components/Other/breadcrumbs";
import "./catalogue.css";
import {
  viewExcel,
  assignCatalogue, // add this import from actions
} from "../../Redux/Actions/franchiseAction";
import { ReactComponent as TowerIcon } from "../../Global Icons/CatalogueIcon/towers.svg";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import UnitDetailsModal from "../../Global Functions/catalogueModal";
import toast from "react-hot-toast";

const ViewResidentialCatalogue = () => {
  const { category_id, project_type, project_id } = useParams();
  const enabled = useSelector((state) => state.franchises?.enabled) || false;
  const enableError =
    useSelector((state) => state.franchises?.enableError) || null;
  const { projectCatalogueExcel: exceldata } = useSelector(
    (state) => state.franchises
  );
  const { selectedBuilderId: builderId, selectedFranchiseId: franchiseId } =
    useSelector((state) => state.franchises); // add builder and franchise from state

  const dispatch = useDispatch();

  const [towerID, setTowerID] = useState("");
  const [towerData, setTowerData] = useState();
  const [checked, setChecked] = useState(false);

  const [unitData, setUnitData] = useState();
  const [update, setUpdate] = useState(false);

  // State to store selected units
  const [units, setUnits] = useState([]);

  useEffect(() => {
    dispatch(viewExcel(project_id, category_id, project_type));
    return () => {
      dispatch({ type: "RESET_EXCEL" });
    };
  }, [project_id, category_id, dispatch, project_type]);

  useEffect(() => {
    if (towerID) {
      const matchedData = exceldata?.data?.result?.find(
        (item) => item._id === towerID
      );
      setTowerData(matchedData);
      setUnits([]); // Reset selected units when tower changes
    }
  }, [towerID, exceldata]);

  useEffect(() => {
    if (towerData) {
      setChecked(towerData?.status === "active" ? true : false);
    }
  }, [towerData]);

  useEffect(() => {
    if (exceldata) {
      setTowerID(exceldata?.data?.towers?.[0]?._id);
    }
  }, [exceldata]);

  useEffect(() => {
    if (enabled) {
      toast.success("Tower Status Changed Successfully!");
      return;
    } else if (enableError) {
      toast.error("Error changing status of this tower");
      return;
    }
  }, [enabled, enableError]);

  useEffect(() => {
    if (unitData) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => document.body.classList.remove("modal-open");
  }, [unitData]);

  // Handle unit click to toggle selection with is_allotted check
  const handleUnitClick = (unit) => {
    const isAllotted = unit.is_allotted === true;
    if (isAllotted) {
      toast.error("This unit is already allotted and cannot be selected");
      return; // Prevent selecting allotted units
    }

    const unitStatus = unit.status || "";
    if (unitStatus !== "avl") {
      toast.error("This unit cannot be selected because it is unavailable");
      return;
    }
    const newUnitObj = {
      catalogue: towerID,
      unit: unit.unit || "",
      catalogue_unit_id: unit.catalogue_unit_id,
      unitno: unit.unitno,
      index: unit.index || "",
      floor: unit.floor || 0,
      lane: unit.lane || 0,
    };

    const isSelected = units.some(
      (u) => u.catalogue_unit_id === newUnitObj.catalogue_unit_id
    );

    if (!isSelected) {
      setUnits((prev) => [...prev, newUnitObj]);
    } else {
      setUnits((prev) =>
        prev.filter((u) => u.catalogue_unit_id !== newUnitObj.catalogue_unit_id)
      );
    }
  };

  // Select all available AND not allotted units in the current tower
  const handleSelectAllCatalogue = () => {
    if (!towerData || !towerData.catalogue) return;

    // Gather all available units with status "avl" and not allotted
    const availableUnits = [];
    towerData.catalogue.forEach((floor) => {
      Object.entries(floor)
        .filter(([key]) => !isNaN(key))
        .forEach(([key, unit]) => {
          if (unit.status === "avl" && unit.is_allotted !== true) {
            availableUnits.push({
              catalogue: towerID,
              unit: unit.unit || "",
              catalogue_unit_id: unit.catalogue_unit_id,
              unitno: unit.unitno,
              index: unit.index || "",
              floor: floor.floor || 0,
              lane: unit.lane || 0,
            });
          }
        });
    });
    setUnits(availableUnits);
  };

  // Assign selected units using the API
  const handleAssignCatalogue = () => {
    if (units.length === 0) {
      toast.error("Please select at least one unit before assigning.");
      return;
    }

    const payload = {
      franchise_id: franchiseId,
      builder_id: builderId,
      project_id: project_id,
      catalogue_id: towerID,
      units: units.map((u) => ({
        unit: u.unit,
        catalogue_unit_id: u.catalogue_unit_id,
        index: u.index,
        unitno: Number(u.unitno) || 0,
        floor: u.floor,
        lane: u.lane,
      })),
    };

    dispatch(assignCatalogue(payload))
      .then(() => {
        toast.success("Catalogue assigned successfully!");
        setUnits([]); 
        dispatch(viewExcel(project_id, category_id, project_type));
      })
      .catch((err) => {
        toast.error("Error assigning catalogue: " + (err?.message || "Failed"));
      });
  };

  return (
    <div className="catalogue-view-page-wrapper">
      <div className="catalogue-view-page-header flex-container flex-align-center flex-justify-between">
        <div className="flex-container flex-align-center">
          <BreadCrumbs
            title="Project Details"
            routeName1="Project List"
            routeName2="Project View"
            route1="/projects"
          />
          <div className="catalogue-view-page-header-right gap-10 flex-container flex-align-center">
            {exceldata?.data?.towers?.map((item, index) => {
              return (
                <button
                  className={`flex-container flex-align-center ${
                    towerID === item._id ? "active-catalogue" : ""
                  }`}
                  id={`tower-btn-${index}`}
                  key={item._id}
                  onClick={() => setTowerID(item._id)}
                >
                  <TowerIcon />
                  <span>{item.tower_name}</span>
                </button>
              );
            })}
          </div>
        </div>
        <div style={{ marginBottom: "1rem", textAlign: "right" }}>
          <button
            className="assign-catalogue-btn"
            onClick={handleAssignCatalogue}
          >
            Assign Catalogue
          </button>
          <button
            className="select-all-catalogue-btn"
            onClick={handleSelectAllCatalogue}
          >
            Select All Catalogue
          </button>
        </div>
      </div>
      {towerData && (
        <div className="catalogue-view-container flex-container">
          <div className="catalogue-view-floors gap-10 flex-container flex-align-center">
            {towerData?.catalogue?.map((item) => (
              <div key={item.floor} className="catalogue-floor-tile mirror">
                <span>{item.floor === 0 ? "G" : item.floor}</span>
              </div>
            ))}
          </div>
          <div className="mirror catalogue-map-container flex-container">
            {towerData?.catalogue?.map((floor) => (
              <div
                key={floor.floor}
                className="catalogue-map-tile grid-container gap-15"
              >
                {Object.entries(floor)
                  .filter(([key]) => !isNaN(key))
                  .map(([key, unit]) => {
                    const isSelected = units.some(
                      (u) => u.catalogue_unit_id === unit.catalogue_unit_id
                    );
                    const isAllotted = unit.is_allotted === true;
                    const cornerYes =
                      unit.corner && unit.corner.toLowerCase() === "yes"; // detect corner

                    return (
                      <div
                        key={unit.catalogue_unit_id}
                        className="mirror catalogue-unit-tile-main gap-15 flex-container flex-align-center"
                        onClick={() => {
                          if (isAllotted) {
                            toast.error(
                              "This unit is already allotted and cannot be selected"
                            );
                            return;
                          }
                          handleUnitClick(unit);
                        }}
                        style={{
                          border: isAllotted
                            ? "2px solid green"
                            : isSelected
                            ? "2px solid green"
                            : unit.status === "unavl"
                            ? "2px solid rgb(230, 73, 0)"
                            : unit.status === "avl"
                            ? "2px solid rgb(6, 170, 0)"
                            : unit.status === "onhold"
                            ? "2px solid rgb(198, 205, 0)"
                            : unit.status === "sold"
                            ? "2px solid rgb(189, 0, 0)"
                            : "none",
                          cursor:
                            isAllotted || unit.status !== "avl"
                              ? "not-allowed"
                              : "pointer",
                          backgroundColor: isAllotted ? "lightgreen" : "inherit",
                        }}
                      >
                        <div
                          className="catalogue-tile-unit-no mirror flex-container flex-center"
                          style={{
                            backgroundColor: isAllotted
                              ? "green"
                              : isSelected
                              ? "green"
                              : "#686868",
                            border: "none",
                          }}
                        >
                          <span title={unit.unitno}>{unit.unitno}</span>
                        </div>
                        <div
                          className="catalogue-tile-unit-type"
                          style={{ textTransform: "capitalize" }}
                        >
                          <span>{unit.unit}</span>
                          {cornerYes && (
                            <span className="plot-tile-type">Corner</span>
                          )}
                        </div>
                      </div>
                    );
                  })}
              </div>
            ))}
          </div>
        </div>
      )}
      {unitData && (
        <UnitDetailsModal unit={unitData} onClose={() => setUnitData(null)} />
      )}
    </div>
  );
};

export default ViewResidentialCatalogue;
